export default "__VITE_ASSET__BroxrvG3__"